module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-products-skin-care-cream-en.8c7e4f38.png";